<div class="reset-password-page mat-typography custom-input flex-column justify-start align-stretch">
  <!-- Header-->
  <div class="reset-password-page-header full-size flex-1">
    <app-header imageUrl="./assets/imgs/backgrounds/signin.jpg">
      <!-- back button-->
      <app-back-button [stopNavigation]="true"
                       (goBack)="cancel()"></app-back-button>
    </app-header>
  </div>

  <!-- form container-->
  <div class="reset-password-container centered">
    <app-reset-password [token]="changePasswordToken"
                        (resetPassword)="resetPassword($event)"
                        (cancel)="cancel()"
                        [submitting]="submitting"></app-reset-password>
  </div>
</div>
